/*** 
 * 描述：系统公共的403没有权限部分
 */ 
import { Component } from '@angular/core';

@Component({
  selector: 'sw-403',
  templateUrl: './403.html',
})

export class SwException403Component {

}